export default __webpack_public_path__ + "static/media/proj14.a3676931.png";